var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.environment)?_c('div',{staticClass:"github-fork-ribbon-wrapper left fixed",on:{"click":function($event){_vm.environment = ''}}},[_c('div',{staticClass:"github-fork-ribbon red"},[_c('span',{staticClass:"github-fork-ribbon-text"},[_vm._v(_vm._s(_vm.environment))])])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }